import React, { useEffect } from 'react';

import { SOURCE } from '@laigu/constants';
import { useChannel } from '@laigu/store';
import BrowserIcon from '../../browser-icon';
import MyIcon from '../../my-icon';

const { searchListSource, openListSource, sourceMap } = SOURCE;

const iconMap = {
  direct: <MyIcon type='ecoboost-iconfontic_direct' />,
  link: <MyIcon type='ecoboost-iconfontic_link' />,
  host: <MyIcon type='ecoboost-iconfontic_jieru' />
};

const getHost = (url: string): string => {
  const a = document.createElement('a');
  a.href = url;
  return a.hostname;
};

const Reffer = ({
  visitInfo,
  source,
  subSource,
  sourceType
}: {
  visitInfo: VisitInfo;
  source?: string;
  subSource?: string;
  sourceType?: string;
}): JSX.Element => {
  const { channelList, getChannelList } = useChannel();
  useEffect(() => {
    getChannelList();
  }, []);

  const firstSessionPage = visitInfo?.first_visit_page_source_by_session || '';
  const firstkeywordPage = visitInfo?.first_visit_page_source_keyword_by_session || '';

  const firstUrlPage = visitInfo.first_visit_page_source_url_by_session;

  let sourceName = '直接访问';
  let icon = null;

  // 由于会定期清理超过半年的数据  会有visit_info = null 的情况
  if (!visitInfo.id && source && source in sourceMap) {
    sourceName = sourceMap[source as keyof typeof sourceMap];
    icon = <BrowserIcon browser={source} />;
  }

  const isSearchEngine = searchListSource.includes(firstSessionPage);
  const isSearchType = openListSource.includes(firstSessionPage);
  if (isSearchEngine || isSearchType) {
    if (isSearchEngine && firstSessionPage in sourceMap) {
      sourceName = sourceMap[firstSessionPage as keyof typeof sourceMap];
      icon = <BrowserIcon browser={firstSessionPage} />;
    }
    if (isSearchType && firstSessionPage in sourceMap) {
      sourceName = sourceMap[firstSessionPage as keyof typeof sourceMap];
      icon = iconMap.host;
    }
  } else if (firstUrlPage) {
    sourceName = getHost(firstUrlPage);
    icon = iconMap.link;
  }

  sourceName = String(sourceName ?? '');

  // 关键词存在加上关键词
  if (firstkeywordPage) {
    sourceName += ` - ${firstkeywordPage}`;
  } else {
    if (firstSessionPage === 'weixin_kf' && source === 'weixin_kf') {
      const weixin_kf = channelList.find((x: any) => x.name === 'weixin_kf');
      const weixin_kf_name = weixin_kf?.sub_source?.find((y: any) => y.name === subSource);
      if (weixin_kf_name) {
        sourceName += ` - ${weixin_kf_name.display_name}`;
      }
    } else if (firstSessionPage === 'redbook' && source === 'redbook' && subSource && subSource.length > 0) {
      const redbook = channelList.find((x: any) => x.name === 'redbook');
      const redbook_name = redbook?.sub_source?.find((y: any) => y.name === subSource);
      if (redbook_name) {
        if (sourceType === 'redbook_kos') {
          sourceName = `${redbook_name.display_name}`;
        } else {
          sourceName += ` - ${redbook_name.display_name}`;
        }
      }
    } else if (firstSessionPage === 'douyin' && source === 'douyin' && subSource && subSource.length > 0) {
      const douyin = channelList.find((x: any) => x.name === 'douyin');
      const douyin_name = douyin?.sub_source?.find((y: any) => y.name === subSource);
      if (douyin_name) {
        sourceName += ` - ${douyin_name.display_name}`;
      }
    } else if (firstSessionPage === 'wx_video' && source === 'wx_video' && subSource && subSource.length > 0) {
      const wx_video = channelList.find((x: any) => x.name === 'wx_video');
      const wx_video_name = wx_video?.sub_source?.find((y: any) => y.name === subSource);
      if (wx_video_name) {
        sourceName += ` - ${wx_video_name.display_name}`;
      }
    }
  }

  return (
    <span title={sourceName}>
      {icon ? <span style={{ margin: '0 5px 0 0' }}>{icon}</span> : null}
      {sourceName}
    </span>
  );
};
export default Reffer;
